module.exports = __webpack_public_path__ + "img/my-handle.7dc2958b.svg";